import { render, staticRenderFns } from "./TestExport.vue?vue&type=template&id=4828f034&scoped=true&"
import script from "./TestExport.vue?vue&type=script&lang=js&"
export * from "./TestExport.vue?vue&type=script&lang=js&"
import style0 from "./TestExport.vue?vue&type=style&index=0&id=4828f034&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828f034",
  null
  
)

export default component.exports